import React from "react";
import { useHistory, Link } from "react-router-dom";
import links from "../views/DashboardCrm/FooterPages/data";
import logo from "../assets/images/header-logo.png";

const NewFooter = (props) => {
  const history = useHistory();
  return (
    <div>
      {/* <div className="container"> */}
      <footer
        className="py-3 my-4 mb-0 shadow-lg w-100"
        style={{
          background: "rgba(40, 40, 40, 0.80)",
          color: "#fff",
          backdropFilter: "blur(30px)",
        }}
      >
        <ul className="nav justify-content-center mb-2 mt-4 fs-16 fw-500">
          {links.map((dd, index) => (
            <li className="nav-item" key={index}>
              {dd.name === "Brochure" ? (
                <a href={dd.path} download className="nav-link px-2 text-light">
                  {dd.name}
                </a>
              ) : (
                <Link to={dd.path}>
                  <p className="nav-link px-2 text-light">{dd.name}</p>
                </Link>
              )}
            </li>
          ))}
        </ul>

        <p className="text-center text-light fs-16 fw-600">
          &copy; {new Date().getFullYear()} Department of Power, Government of Nagaland
        </p>
      </footer>
      {/* </div> */}
    </div>
  );
};

export default NewFooter;
